import types from "./types"

const INITIAL_STATE = {
    person: {
      //  name: 'Przemysława',
      //  surname: 'Kowalski',
      //  maidaneName: 'Ziemniaczek',
      //  sex: 0,
      //  birthDate: '1940-12-05',
      //  formatBirthDate: '05.12.1940r.',
      //  deathDate: '1978-12-05',
      //  formatDeathDate: '05.12.1978r.',
      //  massDate: '1978-12-08',
      //  massTime: '12:00',
      //  rosaryTime: '11:30',
      name: '',
      surname: '',
      maidaneName: '',
      sex: false,
      birthDate: '',
      formatBirthDate: '',
      deathDate: '',
      formatDeathDate: '',
      massDate: '',
      massTime: '',
      rosaryTime: '',
      rosaries: [],
      rosaryText: '',
      additionalRosaryText: '',

      age: '',
      burial: false,
      formatBurial: '',
      formatMassDate: '',
      massPlaceId: '',
      massPlace: '',
      massPlaceAddress: '',
      formatMassTime: '',
      funeralPlaceId: '',
      funeralPlace: '',
      funeralPlaceAddress: '',
      formatFamily: '',
      familyNoticePlural: false,
      family: '',
      quote: '',
      image: '',
      definition: '',
      formatDefinition: '',
      IsRosary: false,
      compactObituaryLayout: false,
      gone: '',
      ourLovely: '',
      massDay: '',
      lived: '',
      died: ''
    }
  }
  
const personReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
      case types.UPDATE_PERSON: {
        return {
          ...state,
          person: {
            ...state.person,
            ...action.updatedPerson
          }
        }
      }
      case types.RESET_PERSON:
        return {
          ...state,
          person: INITIAL_STATE.person
        }
      default:
        return state
    }
  }

  export default personReducer;
